import AcademicComponentEditorComponent from './containers/academicComponentEditorComponent'

export { default as AcademicComponentEditorLayout } from './components/academicComponentEditorLayout' 

export default AcademicComponentEditorComponent